import script from "./DetailPengajuan.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailPengajuan.vue?vue&type=script&setup=true&lang=ts"

import "./DetailPengajuan.vue?vue&type=style&index=0&id=b6dc66fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6dc66fe"]])

export default __exports__